import { createSvgIcon } from './_base';

export const CrossIcon = createSvgIcon(
  '0 0 18 18',
  <path d="m10.152 9 4.61-4.61a.815.815 0 0 0-1.153-1.151L9 7.848l-4.61-4.61a.815.815 0 1 0-1.15 1.154L7.848 9l-4.61 4.61a.815.815 0 0 0 1.153 1.151L9 10.152l4.61 4.61a.815.815 0 0 0 1.151-1.153L10.152 9z" />
);
